export const environment = {
  production: true,
  envName: 'staging',
  enableConsoleLogs: false,
  baseUrl: 'https://carwashstg.way.com/api',
  apiVersion: 'v1',
  imageUrl: 'https://carwash-dev-bucket.s3.ap-south-1.amazonaws.com/',
  // Kept on one line: a reflow makes secret scanners read the publishable key as new.
  // prettier-ignore
  stripePublicKey: 'pk_test_51SfbkiPUhsNN0DnfoqbvfvCBSRckUXAXcw1hCJABdWmOUzV2xH5orVzkIqIqvJkScQNZqY5DGkErs5e6Bb4VLvaj00ot5WUhUI',
  superAdminApiKey: '636ec1e2-8b42-4ec7-89e9-2fe7a5e4c287',
  amplitudeApiKey: '96fa2b83a4f052358612ac28c818e9bb',
  rhombusApiKey: 'nfsHDKKJQSCQWQJWbDjuUg',
  realtimeStreamPath: 'events/stream',
  remoteLogging: {
    enabled: false, // Logging only in production
    endpoint: 'https://in.logs.betterstack.com',
    token: 'G7fmwQbm2Tj7XvKgbHQh2LoY',
    minLevel: 'DEBUG',
    batchIntervalMs: 5000,
  },
  printer: {
    enabled: true,
    host: '10.12.1.140',
    port: 9100,
    charsPerLine: 48,
    connectTimeoutMs: 2500,
  },
  bulkImport: {
    piiMaskedOnSave: true,
  },
};
